import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiMapPin, FiClock, FiFilter, FiSearch, FiChevronRight, FiExternalLink, FiPlus, FiX, FiCheck, FiAlertCircle, FiUsers, FiVideo, FiRepeat, FiDownload, FiLink, FiInfo, FiUpload, FiRefreshCw, FiUser, FiGlobe, FiCompass } = FiIcons;

// Mock data for events - this would be replaced with actual data later
const eventsData = [
  {
    id: 1,
    title: "Texas Republican Convention",
    date: "2024-06-15",
    time: "09:00 AM",
    endTime: "05:00 PM",
    location: "Fort Worth, TX",
    city: "Fort Worth",
    state: "TX",
    venue: "Fort Worth Convention Center",
    description: "Annual gathering of Texas Republicans to discuss platform and elect party leadership.",
    organizer: "Texas GOP",
    hostId: 1, // ID linking to a user profile
    hostProfile: "/profile/texasgop",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=400&h=250&fit=crop",
    rsvpLink: "https://texasgop.org/convention",
    category: "Convention",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "1201 Houston St, Fort Worth, TX 76102"
  },
  {
    id: 2,
    title: "Second Amendment Rally",
    date: "2024-05-28",
    time: "11:00 AM",
    endTime: "02:00 PM",
    location: "Austin, TX",
    city: "Austin",
    state: "TX",
    venue: "Texas State Capitol",
    description: "Rally in support of Second Amendment rights and responsible gun ownership.",
    organizer: "Texas Gun Rights Coalition",
    hostId: 2,
    hostProfile: "/profile/texasgunrights",
    image: "https://images.unsplash.com/photo-1553831755-2a0a5a9b033d?w=400&h=250&fit=crop",
    rsvpLink: "https://txgunrights.org/rally",
    category: "Rally",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "1100 Congress Ave, Austin, TX 78701"
  },
  {
    id: 3,
    title: "Conservative Business Networking",
    date: "2024-06-05",
    time: "06:30 PM",
    endTime: "08:30 PM",
    location: "Houston, TX",
    city: "Houston",
    state: "TX",
    venue: "Houston Business Center",
    description: "Connect with like-minded conservative business owners and entrepreneurs.",
    organizer: "Conservative Business Alliance",
    hostId: 3,
    hostProfile: "/profile/cba",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=400&h=250&fit=crop",
    rsvpLink: "https://conservativebusiness.org/network",
    category: "Networking",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "monthly",
      interval: 1,
      weekday: "wednesday",
      monthDay: "first",
      endDate: ""
    },
    address: "1200 Smith St, Houston, TX 77002"
  },
  {
    id: 4,
    title: "Town Hall with Senator Cruz",
    date: "2024-06-10",
    time: "07:00 PM",
    endTime: "09:00 PM",
    location: "Dallas, TX",
    city: "Dallas",
    state: "TX",
    venue: "Dallas Civic Center",
    description: "Town hall meeting with Senator Ted Cruz to discuss current issues and answer constituent questions.",
    organizer: "Office of Senator Cruz",
    hostId: 4,
    hostProfile: "/profile/tedcruz",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=400&h=250&fit=crop",
    rsvpLink: "https://cruz.senate.gov/townhall",
    category: "Town Hall",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "650 S Griffin St, Dallas, TX 75202"
  },
  {
    id: 5,
    title: "Young Republicans Mixer",
    date: "2024-06-20",
    time: "08:00 PM",
    endTime: "11:00 PM",
    location: "San Antonio, TX",
    city: "San Antonio",
    state: "TX",
    venue: "Riverwalk Plaza",
    description: "Social gathering for young Republicans to network and discuss conservative principles.",
    organizer: "Young Republicans of San Antonio",
    hostId: 5,
    hostProfile: "/profile/sayoungrepublicans",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=400&h=250&fit=crop",
    rsvpLink: "https://sayoungrepublicans.org/mixer",
    category: "Social",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "monthly",
      interval: 1,
      weekday: "thursday",
      monthDay: "third",
      endDate: ""
    },
    address: "849 E Commerce St, San Antonio, TX 78205"
  },
  {
    id: 6,
    title: "Economic Policy Forum",
    date: "2024-05-25",
    time: "10:00 AM",
    endTime: "12:00 PM",
    location: "Houston, TX",
    city: "Houston",
    state: "TX",
    venue: "Rice University",
    description: "Discussion on free-market economic policies and their impact on American prosperity.",
    organizer: "Conservative Economic Institute",
    hostId: 6,
    hostProfile: "/profile/cei",
    image: "https://images.unsplash.com/photo-1551636898-47668aa61de2?w=400&h=250&fit=crop",
    rsvpLink: "https://conservativeecon.org/forum",
    category: "Forum",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "6100 Main St, Houston, TX 77005"
  },
  {
    id: 7,
    title: "Debate Watch Party",
    date: "2024-06-25",
    time: "07:30 PM",
    endTime: "10:00 PM",
    location: "Austin, TX",
    city: "Austin",
    state: "TX",
    venue: "Austin Republican Headquarters",
    description: "Join fellow Republicans to watch the presidential debate.",
    organizer: "Travis County Republicans",
    hostId: 7,
    hostProfile: "/profile/traviscountygop",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=400&h=250&fit=crop",
    rsvpLink: "https://traviscountygop.org/debate",
    category: "Watch Party",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "807 Brazos St, Austin, TX 78701"
  },
  {
    id: 8,
    title: "Republican Women's Luncheon",
    date: "2024-06-12",
    time: "12:00 PM",
    endTime: "02:00 PM",
    location: "Dallas, TX",
    city: "Dallas",
    state: "TX",
    venue: "Dallas Country Club",
    description: "Monthly luncheon featuring guest speakers and networking for Republican women.",
    organizer: "Dallas Republican Women",
    hostId: 8,
    hostProfile: "/profile/dallasrepublicanwomen",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=400&h=250&fit=crop",
    rsvpLink: "https://dallasrepublicanwomen.org/luncheon",
    category: "Luncheon",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "monthly",
      interval: 1,
      weekday: "wednesday",
      monthDay: "second",
      endDate: ""
    },
    address: "4100 Beverly Dr, Dallas, TX 75205"
  },
  {
    id: 9,
    title: "Constitution Study Group",
    date: "2024-06-08",
    time: "02:00 PM",
    endTime: "04:00 PM",
    location: "Fort Worth, TX",
    city: "Fort Worth",
    state: "TX",
    venue: "Community Library",
    description: "Weekly study group focused on the U.S. Constitution and founding principles.",
    organizer: "Constitutional Patriots",
    hostId: 9,
    hostProfile: "/profile/constitutionalpatriots",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=250&fit=crop",
    rsvpLink: "https://constitutionalpatriots.org/study",
    category: "Study Group",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "weekly",
      interval: 1,
      weekday: "saturday",
      monthDay: "",
      endDate: ""
    },
    address: "500 W 3rd St, Fort Worth, TX 76102"
  },
  {
    id: 10,
    title: "Campaign Volunteer Training",
    date: "2024-06-01",
    time: "09:00 AM",
    endTime: "12:00 PM",
    location: "San Antonio, TX",
    city: "San Antonio",
    state: "TX",
    venue: "Campaign Headquarters",
    description: "Training session for campaign volunteers on effective canvassing and voter outreach.",
    organizer: "Republican Party of Bexar County",
    hostId: 10,
    hostProfile: "/profile/bexargop",
    image: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=400&h=250&fit=crop",
    rsvpLink: "https://bexargop.org/volunteer",
    category: "Training",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "1800 NE Loop 410, San Antonio, TX 78217"
  },
  {
    id: 11,
    title: "Virtual Town Hall on Border Security",
    date: "2024-06-18",
    time: "06:00 PM",
    endTime: "07:30 PM",
    location: "Online",
    city: "",
    state: "",
    venue: "Zoom Webinar",
    description: "Join our virtual town hall to discuss border security policies and solutions with expert panelists.",
    organizer: "Border Security Coalition",
    hostId: 11,
    hostProfile: "/profile/bordersecuritycoalition",
    image: "https://images.unsplash.com/photo-1609234656432-603fd648aee0?w=400&h=250&fit=crop",
    rsvpLink: "https://bordersecurity.org/townhall",
    category: "Town Hall",
    isVirtual: true,
    virtualLink: "https://zoom.us/j/123456789",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: ""
  },
  {
    id: 12,
    title: "Weekly Conservative Prayer Breakfast",
    date: "2024-06-08",
    time: "08:00 AM",
    endTime: "09:30 AM",
    location: "Houston, TX",
    city: "Houston",
    state: "TX",
    venue: "First Baptist Church",
    description: "Join fellow conservatives for breakfast, fellowship, and prayer for our nation.",
    organizer: "Faith & Freedom Coalition",
    hostId: 12,
    hostProfile: "/profile/faithandfreedom",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=250&fit=crop",
    rsvpLink: "https://faithandfreedom.org/breakfast",
    category: "Faith",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "weekly",
      interval: 1,
      weekday: "saturday",
      monthDay: "",
      endDate: ""
    },
    address: "7401 Katy Freeway, Houston, TX 77024"
  },
  {
    id: 13,
    title: "Conservative Book Club",
    date: "2024-06-15",
    time: "10:00 AM",
    endTime: "12:00 PM",
    location: "Austin, TX",
    city: "Austin",
    state: "TX",
    venue: "Central Library",
    description: "Monthly meeting to discuss books on conservative philosophy, economics, and politics.",
    organizer: "Austin Conservative Readers",
    hostId: 13,
    hostProfile: "/profile/austinconservativereaders",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=250&fit=crop",
    rsvpLink: "https://austinconservativereaders.org",
    category: "Education",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "monthly",
      interval: 1,
      weekday: "saturday",
      monthDay: "third",
      endDate: ""
    },
    address: "710 W Cesar Chavez St, Austin, TX 78701"
  },
  {
    id: 14,
    title: "Weekly Online Conservative Roundtable",
    date: "2024-05-30",
    time: "07:00 PM",
    endTime: "08:30 PM",
    location: "Online",
    city: "",
    state: "",
    venue: "Google Meet",
    description: "Weekly virtual discussion group on current conservative issues and policy ideas.",
    organizer: "Conservative Thinkers Network",
    hostId: 14,
    hostProfile: "/profile/conservativethinkers",
    image: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=400&h=250&fit=crop",
    rsvpLink: "https://conservativethinkers.org/roundtable",
    category: "Discussion",
    isVirtual: true,
    virtualLink: "https://meet.google.com/abc-defg-hij",
    isRecurring: true,
    recurrencePattern: {
      frequency: "weekly",
      interval: 1,
      weekday: "thursday",
      monthDay: "",
      endDate: ""
    },
    address: ""
  },
  {
    id: 15,
    title: "Virginia Beach Republican Meetup",
    date: "2024-06-12",
    time: "07:00 PM",
    endTime: "09:00 PM",
    location: "Virginia Beach, VA",
    city: "Virginia Beach",
    state: "VA",
    venue: "Oceanfront Community Center",
    description: "Monthly meeting of Virginia Beach Republicans to discuss local issues and upcoming elections.",
    organizer: "Virginia Beach Republican Committee",
    hostId: 15,
    hostProfile: "/profile/vabeachgop",
    image: "https://images.unsplash.com/photo-1565728744382-61accd4aa148?w=400&h=250&fit=crop",
    rsvpLink: "https://vabeachgop.org/meetings",
    category: "Meeting",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "monthly",
      interval: 1,
      weekday: "wednesday",
      monthDay: "second",
      endDate: ""
    },
    address: "2100 Atlantic Ave, Virginia Beach, VA 23451"
  },
  {
    id: 16,
    title: "Richmond Conservative Coalition Fundraiser",
    date: "2024-06-18",
    time: "06:00 PM",
    endTime: "09:00 PM",
    location: "Richmond, VA",
    city: "Richmond",
    state: "VA",
    venue: "Jefferson Hotel",
    description: "Annual fundraising dinner supporting conservative candidates in Virginia.",
    organizer: "Virginia Conservative Coalition",
    hostId: 16,
    hostProfile: "/profile/vaconservatives",
    image: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=400&h=250&fit=crop",
    rsvpLink: "https://vaconservatives.org/fundraiser",
    category: "Fundraiser",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "101 W Franklin St, Richmond, VA 23220"
  },
  {
    id: 17,
    title: "Norfolk GOP Candidate Forum",
    date: "2024-06-05",
    time: "07:00 PM",
    endTime: "09:30 PM",
    location: "Norfolk, VA",
    city: "Norfolk",
    state: "VA",
    venue: "Norfolk Waterside Marriott",
    description: "Meet Republican candidates running for local and state offices in Norfolk.",
    organizer: "Norfolk Republican Party",
    hostId: 17,
    hostProfile: "/profile/norfolkgop",
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=400&h=250&fit=crop",
    rsvpLink: "https://norfolkgop.org/forum",
    category: "Forum",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "235 E Main St, Norfolk, VA 23510"
  },
  {
    id: 18,
    title: "Alexandria Conservative Breakfast Club",
    date: "2024-06-07",
    time: "07:30 AM",
    endTime: "09:00 AM",
    location: "Alexandria, VA",
    city: "Alexandria",
    state: "VA",
    venue: "Old Town Diner",
    description: "Weekly gathering of conservatives in Alexandria to discuss current events over breakfast.",
    organizer: "Alexandria Conservative Coalition",
    hostId: 18,
    hostProfile: "/profile/alexconservatives",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=250&fit=crop",
    rsvpLink: "https://alexconservatives.org/breakfast",
    category: "Social",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "weekly",
      interval: 1,
      weekday: "friday",
      monthDay: "",
      endDate: ""
    },
    address: "123 King St, Alexandria, VA 22314"
  }
];

// Past events
const pastEventsData = [
  {
    id: 101,
    title: "Lincoln Day Dinner",
    date: "2024-04-15",
    time: "06:00 PM",
    endTime: "09:00 PM",
    location: "Houston, TX",
    city: "Houston",
    state: "TX",
    venue: "Hilton Downtown",
    description: "Annual fundraising dinner celebrating Abraham Lincoln and Republican values.",
    organizer: "Harris County Republican Party",
    hostId: 15,
    hostProfile: "/profile/harriscountygop",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=400&h=250&fit=crop",
    category: "Fundraiser",
    isVirtual: false,
    virtualLink: "",
    isRecurring: true,
    recurrencePattern: {
      frequency: "yearly",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "1600 Lamar St, Houston, TX 77010"
  },
  {
    id: 102,
    title: "Tax Reform Panel",
    date: "2024-04-20",
    time: "10:00 AM",
    endTime: "12:00 PM",
    location: "Dallas, TX",
    city: "Dallas",
    state: "TX",
    venue: "Dallas Convention Center",
    description: "Panel discussion on Republican tax reform initiatives and their economic impact.",
    organizer: "Texas Conservative Coalition",
    hostId: 16,
    hostProfile: "/profile/texasconservativecoalition",
    image: "https://images.unsplash.com/photo-1551636898-47668aa61de2?w=400&h=250&fit=crop",
    category: "Panel",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "650 S Griffin St, Dallas, TX 75202"
  },
  {
    id: 103,
    title: "Border Security Forum",
    date: "2024-05-01",
    time: "01:00 PM",
    endTime: "03:00 PM",
    location: "McAllen, TX",
    city: "McAllen",
    state: "TX",
    venue: "McAllen Convention Center",
    description: "Discussion on border security challenges and Republican policy solutions.",
    organizer: "Border Security Coalition",
    hostId: 11,
    hostProfile: "/profile/bordersecuritycoalition",
    image: "https://images.unsplash.com/photo-1473163928189-364b2c4e1135?w=400&h=250&fit=crop",
    category: "Forum",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "700 Convention Center Blvd, McAllen, TX 78501"
  },
  {
    id: 104,
    title: "Virginia GOP Spring Conference",
    date: "2024-04-28",
    time: "09:00 AM",
    endTime: "05:00 PM",
    location: "Richmond, VA",
    city: "Richmond",
    state: "VA",
    venue: "Greater Richmond Convention Center",
    description: "Statewide gathering of Virginia Republicans to discuss strategy for upcoming elections.",
    organizer: "Republican Party of Virginia",
    hostId: 19,
    hostProfile: "/profile/vagop",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=250&fit=crop",
    category: "Conference",
    isVirtual: false,
    virtualLink: "",
    isRecurring: false,
    recurrencePattern: {
      frequency: "",
      interval: 1,
      weekday: "",
      monthDay: "",
      endDate: ""
    },
    address: "403 N 3rd St, Richmond, VA 23219"
  }
];

const Events = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [showPastEvents, setShowPastEvents] = useState(false);
  const [showAddEventForm, setShowAddEventForm] = useState(false);
  const [showEventDetail, setShowEventDetail] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showLocationFilters, setShowLocationFilters] = useState(false);
  const [newEvent, setNewEvent] = useState({
    title: '',
    date: '',
    time: '',
    endTime: '',
    location: '',
    city: '',
    state: '',
    venue: '',
    description: '',
    organizer: '',
    category: 'Convention',
    rsvpLink: '',
    isVirtual: false,
    virtualLink: '',
    isRecurring: false,
    recurrencePattern: {
      frequency: '',
      interval: 1,
      weekday: '',
      monthDay: '',
      endDate: ''
    },
    address: ''
  });
  const [submissionStatus, setSubmissionStatus] = useState({
    type: '',
    message: ''
  });

  // Available categories from the events data
  const categories = ['All', ...new Set([...eventsData, ...pastEventsData].map(event => event.category))];

  // Get all available states from events data
  const availableStates = [...new Set([...eventsData, ...pastEventsData]
    .filter(event => event.state)
    .map(event => event.state))]
    .sort();

  // Get cities for the selected state
  const availableCities = [...new Set([...eventsData, ...pastEventsData]
    .filter(event => !selectedState || event.state === selectedState)
    .filter(event => event.city)
    .map(event => event.city))]
    .sort();

  // Recurrence pattern options
  const frequencies = [
    { value: "weekly", label: "Weekly" },
    { value: "biweekly", label: "Every two weeks" },
    { value: "monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" }
  ];

  // Days of the week for recurring events
  const weekdays = [
    { value: "sunday", label: "Sunday" },
    { value: "monday", label: "Monday" },
    { value: "tuesday", label: "Tuesday" },
    { value: "wednesday", label: "Wednesday" },
    { value: "thursday", label: "Thursday" },
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" }
  ];

  // Week options for monthly recurrence
  const monthDays = [
    { value: "first", label: "First" },
    { value: "second", label: "Second" },
    { value: "third", label: "Third" },
    { value: "fourth", label: "Fourth" },
    { value: "last", label: "Last" }
  ];

  // Filter events based on search term, category, state, and city
  const filterEvents = (events) => {
    return events.filter(event => {
      // Text search matching
      const matchesSearch = 
        event.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
        event.description.toLowerCase().includes(searchTerm.toLowerCase()) || 
        event.location.toLowerCase().includes(searchTerm.toLowerCase()) || 
        event.organizer.toLowerCase().includes(searchTerm.toLowerCase());
      
      // Category matching
      const matchesCategory = selectedCategory === 'All' || event.category === selectedCategory;
      
      // Location matching - state and city
      const matchesState = !selectedState || event.state === selectedState;
      const matchesCity = !selectedCity || event.city === selectedCity;
      
      return matchesSearch && matchesCategory && matchesState && matchesCity;
    });
  };

  // Sort events by date
  const sortEvents = (events) => {
    return [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  // Get current events (not past)
  const currentEvents = sortEvents(filterEvents(eventsData));

  // Get past events
  const pastEvents = sortEvents(filterEvents(pastEventsData));

  // Reset location filters
  const resetLocationFilters = () => {
    setSelectedState('');
    setSelectedCity('');
  };

  // Format date for display
  const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Format time for display (12-hour format with AM/PM)
  const formatTime = (timeString) => {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${ampm}`;
  };

  // Get the next occurrence of a recurring event
  const getNextOccurrence = (event) => {
    if (!event.isRecurring) return event.date;
    
    const startDate = new Date(event.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (startDate >= today) return event.date;

    // Handle different recurrence patterns based on the new structure
    const pattern = event.recurrencePattern;
    
    if (pattern.frequency === "weekly" && pattern.weekday === "saturday") {
      let nextDate = new Date(today);
      const dayToAdd = (6 - today.getDay() + 7) % 7;
      nextDate.setDate(today.getDate() + (dayToAdd === 0 ? 7 : dayToAdd));
      return nextDate.toISOString().split('T')[0];
    }
    
    if (pattern.frequency === "monthly" && pattern.weekday === "thursday" && pattern.monthDay === "third") {
      let nextDate = new Date(today);
      nextDate.setDate(1); // Start at the beginning of the month
      
      // Find the first Thursday
      while (nextDate.getDay() !== 4) {
        nextDate.setDate(nextDate.getDate() + 1);
      }
      
      // Move to third Thursday
      nextDate.setDate(nextDate.getDate() + 14);
      
      // If we've passed this month's third Thursday, move to next month
      if (nextDate < today) {
        nextDate = new Date(today);
        nextDate.setMonth(nextDate.getMonth() + 1);
        nextDate.setDate(1);
        
        // Find the first Thursday of next month
        while (nextDate.getDay() !== 4) {
          nextDate.setDate(nextDate.getDate() + 1);
        }
        
        // Move to third Thursday
        nextDate.setDate(nextDate.getDate() + 14);
      }
      
      return nextDate.toISOString().split('T')[0];
    }
    
    // Handle other patterns (simplified for demonstration)
    return event.date;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('recurrencePattern.')) {
      // Handle nested recurrence pattern fields
      const field = name.split('.')[1];
      setNewEvent({
        ...newEvent,
        recurrencePattern: {
          ...newEvent.recurrencePattern,
          [field]: value
        }
      });
    } else {
      // Handle top-level fields
      setNewEvent({
        ...newEvent,
        [name]: type === 'checkbox' ? checked : value
      });
      
      // Special handling for isVirtual toggle
      if (name === 'isVirtual' && checked) {
        setNewEvent(prev => ({
          ...prev,
          [name]: checked,
          location: 'Online',
          city: '',
          state: '',
          address: ''
        }));
      } else if (name === 'isVirtual' && !checked) {
        setNewEvent(prev => ({
          ...prev,
          [name]: checked,
          virtualLink: '',
          location: ''
        }));
      }
      
      // Handle state selection - reset city when state changes
      if (name === 'state') {
        setNewEvent(prev => ({
          ...prev,
          [name]: value,
          city: '' // Reset city when state changes
        }));
      }
    }
    
    // Reset submission status when user starts editing
    if (submissionStatus.message) {
      setSubmissionStatus({
        type: '',
        message: ''
      });
    }
  };

  // Generate recurrence pattern display text
  const generateRecurrenceText = () => {
    const pattern = newEvent.recurrencePattern;
    if (!pattern.frequency) return "";
    
    switch (pattern.frequency) {
      case 'weekly':
        const weekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `Every ${weekday}`;
      case 'biweekly':
        const biWeekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `Every other ${biWeekday}`;
      case 'monthly':
        const monthDay = monthDays.find(w => w.value === pattern.monthDay)?.label || '';
        const monthWeekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `${monthDay} ${monthWeekday} of every month`;
      case 'yearly':
        return "Once a year";
      default:
        return "";
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Form validation
    if (!newEvent.title || !newEvent.date || !newEvent.time || !newEvent.organizer) {
      setSubmissionStatus({
        type: 'error',
        message: 'Please fill in all required fields (title, date, time, organizer)'
      });
      return;
    }
    
    // Location validation
    if (!newEvent.isVirtual && !newEvent.location) {
      setSubmissionStatus({
        type: 'error',
        message: 'Please enter a location for your in-person event'
      });
      return;
    }
    
    // Virtual event validation
    if (newEvent.isVirtual && !newEvent.virtualLink) {
      setSubmissionStatus({
        type: 'error',
        message: 'Please provide a virtual meeting link for virtual events'
      });
      return;
    }
    
    // Recurring event validation
    if (newEvent.isRecurring) {
      if (!newEvent.recurrencePattern.frequency) {
        setSubmissionStatus({
          type: 'error',
          message: 'Please specify a recurrence frequency for recurring events'
        });
        return;
      }
      
      if ((newEvent.recurrencePattern.frequency === 'weekly' || 
           newEvent.recurrencePattern.frequency === 'biweekly' || 
           newEvent.recurrencePattern.frequency === 'monthly') && 
          !newEvent.recurrencePattern.weekday) {
        setSubmissionStatus({
          type: 'error',
          message: 'Please specify a day of the week for recurring events'
        });
        return;
      }
      
      if (newEvent.recurrencePattern.frequency === 'monthly' && !newEvent.recurrencePattern.monthDay) {
        setSubmissionStatus({
          type: 'error',
          message: 'Please specify which week of the month for monthly recurring events'
        });
        return;
      }
    }
    
    // Generate recurrence text for display
    const recurrenceText = newEvent.isRecurring ? generateRecurrenceText() : "";
    
    // Prepare event data
    const eventData = {
      ...newEvent,
      recurrenceText
    };
    
    // In a real application, this would save to a database
    // For now, we'll just show a success message
    setSubmissionStatus({
      type: 'success',
      message: 'Event submitted successfully! It will be reviewed by an administrator.'
    });
    
    // Reset form after submission
    setTimeout(() => {
      setNewEvent({
        title: '',
        date: '',
        time: '',
        endTime: '',
        location: '',
        city: '',
        state: '',
        venue: '',
        description: '',
        organizer: '',
        category: 'Convention',
        rsvpLink: '',
        isVirtual: false,
        virtualLink: '',
        isRecurring: false,
        recurrencePattern: {
          frequency: '',
          interval: 1,
          weekday: '',
          monthDay: '',
          endDate: ''
        },
        address: ''
      });
      setSubmissionStatus({
        type: '',
        message: ''
      });
      setShowAddEventForm(false);
    }, 3000);
  };

  // Open event details modal
  const openEventDetails = (event) => {
    setSelectedEvent(event);
    setShowEventDetail(true);
  };

  // Close event details modal
  const closeEventDetails = () => {
    setSelectedEvent(null);
    setShowEventDetail(false);
  };

  // Generate Google Calendar event link
  const generateGoogleCalendarLink = (event) => {
    try {
      const startDate = new Date(`${event.date}T${event.time || '00:00'}`);
      const endDate = event.endTime ? new Date(`${event.date}T${event.endTime}`) : new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // Default 2 hours
      
      const startIso = startDate.toISOString().replace(/-|:|\.\d+/g, '');
      const endIso = endDate.toISOString().replace(/-|:|\.\d+/g, '');
      
      const location = event.isVirtual ? event.virtualLink : `${event.venue}, ${event.location}`;
      
      let recurrence = '';
      if (event.isRecurring) {
        // Google Calendar recurrence rules could be added here
        // For simplicity, we'll just mention it's recurring in the description
        recurrence = `\n\nThis is a recurring event: ${event.isRecurring && event.recurrencePattern ? generateRecurrenceTextFromPattern(event.recurrencePattern) : ''}`;
      }
      
      return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${startIso}/${endIso}&details=${encodeURIComponent(event.description + recurrence)}&location=${encodeURIComponent(location)}`;
    } catch (error) {
      console.error("Error generating calendar link:", error);
      return '#';
    }
  };

  // Generate recurrence text from pattern object
  const generateRecurrenceTextFromPattern = (pattern) => {
    if (!pattern || !pattern.frequency) return "";
    
    switch (pattern.frequency) {
      case 'weekly':
        const weekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `Every ${weekday}`;
      case 'biweekly':
        const biWeekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `Every other ${biWeekday}`;
      case 'monthly':
        const monthDay = monthDays.find(w => w.value === pattern.monthDay)?.label || '';
        const monthWeekday = weekdays.find(d => d.value === pattern.weekday)?.label || '';
        return `${monthDay} ${monthWeekday} of every month`;
      case 'yearly':
        return "Once a year";
      default:
        return "";
    }
  };

  // Generate iCal file for event
  const generateICalFile = (event) => {
    try {
      const startDate = new Date(`${event.date}T${event.time || '00:00'}`);
      const endDate = event.endTime ? new Date(`${event.date}T${event.endTime}`) : new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // Default 2 hours
      
      const formatICalDate = (date) => {
        return date.toISOString().replace(/-|:|\.\d+/g, '');
      };
      
      const location = event.isVirtual ? event.virtualLink : `${event.venue}, ${event.location}`;
      
      let icalContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'CALSCALE:GREGORIAN',
        'PRODID:-//GOP Zone//Republican Events//EN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${event.id}@gopzone.com`,
        `SUMMARY:${event.title}`,
        `DTSTAMP:${formatICalDate(new Date())}`,
        `DTSTART:${formatICalDate(startDate)}`,
        `DTEND:${formatICalDate(endDate)}`,
        `DESCRIPTION:${event.description.replace(/\n/g, '\\n')}`,
        `LOCATION:${location}`
      ];
      
      // Add recurrence rule if applicable
      if (event.isRecurring && event.recurrencePattern) {
        const pattern = event.recurrencePattern;
        
        if (pattern.frequency === "weekly" && pattern.weekday === "saturday") {
          icalContent.push('RRULE:FREQ=WEEKLY;BYDAY=SA');
        } else if (pattern.frequency === "monthly" && pattern.weekday === "thursday" && pattern.monthDay === "third") {
          icalContent.push('RRULE:FREQ=MONTHLY;BYDAY=3TH');
        }
        // Add other recurrence patterns as needed
      }
      
      icalContent = icalContent.concat([
        'END:VEVENT',
        'END:VCALENDAR'
      ]);
      
      const blob = new Blob([icalContent.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${event.title.replace(/\s+/g, '_')}.ics`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating iCal file:", error);
    }
  };

  // Generate Apple Calendar link
  const generateAppleCalendarLink = (event) => {
    try {
      const startDate = new Date(`${event.date}T${event.time || '00:00'}`);
      const endDate = event.endTime ? new Date(`${event.date}T${event.endTime}`) : new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // Default 2 hours
      
      const formatICalDate = (date) => {
        return date.toISOString().replace(/-|:|\.\d+/g, '');
      };
      
      const location = event.isVirtual ? event.virtualLink : `${event.venue}, ${event.location}`;
      
      let icalContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'CALSCALE:GREGORIAN',
        'PRODID:-//GOP Zone//Republican Events//EN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${event.id}@gopzone.com`,
        `SUMMARY:${event.title}`,
        `DTSTAMP:${formatICalDate(new Date())}`,
        `DTSTART:${formatICalDate(startDate)}`,
        `DTEND:${formatICalDate(endDate)}`,
        `DESCRIPTION:${event.description.replace(/\n/g, '\\n')}`,
        `LOCATION:${location}`
      ];
      
      // Add recurrence rule if applicable
      if (event.isRecurring && event.recurrencePattern) {
        const pattern = event.recurrencePattern;
        
        if (pattern.frequency === "weekly" && pattern.weekday === "saturday") {
          icalContent.push('RRULE:FREQ=WEEKLY;BYDAY=SA');
        } else if (pattern.frequency === "monthly" && pattern.weekday === "thursday" && pattern.monthDay === "third") {
          icalContent.push('RRULE:FREQ=MONTHLY;BYDAY=3TH');
        }
        // Add other recurrence patterns as needed
      }
      
      icalContent = icalContent.concat([
        'END:VEVENT',
        'END:VCALENDAR'
      ]);
      
      const blob = new Blob([icalContent.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error generating Apple Calendar link:", error);
      return '#';
    }
  };

  // Get next occurrence date for recurring events
  const getNextOccurrenceDate = (event) => {
    if (!event.isRecurring) return formatDate(event.date);
    const nextDate = getNextOccurrence(event);
    return formatDate(nextDate);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }} 
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-patriot-navy mb-4">Republican Events</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Connect with fellow patriots at rallies, town halls, and conservative gatherings across America. Find opportunities to make a difference in your community.
          </p>
        </motion.div>

        {/* Search and Filters */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
            <div className="flex-1 relative">
              <SafeIcon 
                icon={FiSearch} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" 
              />
              <input 
                type="text" 
                placeholder="Search events by title, description, or location..." 
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
              />
            </div>
            <div className="flex flex-wrap gap-2">
              <button 
                onClick={() => setShowLocationFilters(!showLocationFilters)} 
                className="bg-white border border-gray-300 text-gray-700 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors duration-200 flex items-center"
              >
                <SafeIcon icon={FiMapPin} className="h-5 w-5 mr-2 text-patriot-red" />
                <span className="whitespace-nowrap">Location Filter</span>
              </button>
              <button 
                onClick={() => setShowAddEventForm(true)} 
                className="bg-patriot-gold text-patriot-navy px-4 py-3 rounded-lg hover:bg-patriot-gold-dark transition-colors duration-200 flex items-center"
              >
                <SafeIcon icon={FiPlus} className="h-5 w-5 mr-2" />
                <span className="whitespace-nowrap">Submit Event</span>
              </button>
            </div>
          </div>

          {/* Location Filters */}
          {showLocationFilters && (
            <motion.div 
              initial={{ opacity: 0, height: 0 }} 
              animate={{ opacity: 1, height: 'auto' }} 
              exit={{ opacity: 0, height: 0 }} 
              transition={{ duration: 0.3 }} 
              className="bg-white rounded-lg shadow-md p-4 mb-4"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-medium text-patriot-navy flex items-center">
                  <SafeIcon icon={FiCompass} className="h-5 w-5 mr-2 text-patriot-red" />
                  Filter Events by Location
                </h3>
                <button 
                  onClick={resetLocationFilters} 
                  className="text-sm text-patriot-red hover:text-patriot-red-dark flex items-center"
                >
                  <SafeIcon icon={FiX} className="h-4 w-4 mr-1" />
                  Reset
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
                    State
                  </label>
                  <select 
                    id="state" 
                    value={selectedState} 
                    onChange={(e) => {
                      setSelectedState(e.target.value);
                      setSelectedCity(''); // Reset city when state changes
                    }} 
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent"
                  >
                    <option value="">All States</option>
                    {availableStates.map(state => (
                      <option key={state} value={state}>{state}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                    City
                  </label>
                  <select 
                    id="city" 
                    value={selectedCity} 
                    onChange={(e) => setSelectedCity(e.target.value)} 
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                    disabled={!selectedState}
                  >
                    <option value="">All Cities</option>
                    {availableCities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-4 text-sm text-gray-600">
                <div className="flex items-center">
                  <SafeIcon icon={FiInfo} className="h-4 w-4 mr-1 text-gray-500" />
                  <span>
                    {selectedState && selectedCity 
                      ? `Showing events in ${selectedCity}, ${selectedState}`
                      : selectedState 
                        ? `Showing all events in ${selectedState}`
                        : 'Showing events in all locations'
                    }
                  </span>
                </div>
              </div>
            </motion.div>
          )}

          {/* Category Filters */}
          <div className="flex overflow-x-auto pb-2 hide-scrollbar">
            <div className="flex gap-2 flex-nowrap">
              {categories.map((category) => (
                <button 
                  key={category} 
                  onClick={() => setSelectedCategory(category)} 
                  className={`px-3 py-1.5 rounded-md font-medium text-sm transition-colors duration-200 whitespace-nowrap ${
                    selectedCategory === category 
                      ? 'bg-patriot-red text-white' 
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Active Location Filters */}
          {(selectedState || selectedCity) && (
            <div className="flex flex-wrap gap-2 my-4">
              {selectedState && (
                <div className="flex items-center bg-patriot-red bg-opacity-10 text-patriot-red px-3 py-1.5 rounded-full text-sm">
                  <SafeIcon icon={FiGlobe} className="h-3.5 w-3.5 mr-1.5" />
                  <span>State: {selectedState}</span>
                  <button 
                    onClick={() => {
                      setSelectedState('');
                      setSelectedCity('');
                    }} 
                    className="ml-2 text-patriot-red hover:text-patriot-red-dark"
                  >
                    <SafeIcon icon={FiX} className="h-3.5 w-3.5" />
                  </button>
                </div>
              )}
              {selectedCity && (
                <div className="flex items-center bg-patriot-red bg-opacity-10 text-patriot-red px-3 py-1.5 rounded-full text-sm">
                  <SafeIcon icon={FiMapPin} className="h-3.5 w-3.5 mr-1.5" />
                  <span>City: {selectedCity}</span>
                  <button 
                    onClick={() => setSelectedCity('')} 
                    className="ml-2 text-patriot-red hover:text-patriot-red-dark"
                  >
                    <SafeIcon icon={FiX} className="h-3.5 w-3.5" />
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Toggle Past Events */}
          <div className="flex justify-end">
            <button 
              onClick={() => setShowPastEvents(!showPastEvents)} 
              className="text-patriot-red hover:text-patriot-red-dark font-medium text-sm flex items-center"
            >
              {showPastEvents ? 'Hide Past Events' : 'Show Past Events'}
              <SafeIcon 
                icon={FiChevronRight} 
                className={`ml-1 h-4 w-4 transition-transform ${showPastEvents ? 'rotate-90' : ''}`} 
              />
            </button>
          </div>
        </div>

        {/* Current Events */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-patriot-navy mb-6 flex items-center flex-wrap">
            <SafeIcon icon={FiCalendar} className="h-6 w-6 mr-2 text-patriot-red" />
            Upcoming Events
            {(selectedState || selectedCity) && (
              <span className="ml-2 text-lg text-gray-600 font-normal">
                {selectedCity ? `in ${selectedCity}, ${selectedState}` : selectedState ? `in ${selectedState}` : ''}
              </span>
            )}
          </h2>

          {currentEvents.length === 0 ? (
            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <p className="text-gray-600">
                {(selectedState || selectedCity || selectedCategory !== 'All' || searchTerm) 
                  ? 'No upcoming events found matching your criteria.'
                  : 'No upcoming events found.'
                }
              </p>
              {(selectedState || selectedCity || selectedCategory !== 'All' || searchTerm) && (
                <button 
                  onClick={() => {
                    setSelectedState('');
                    setSelectedCity('');
                    setSelectedCategory('All');
                    setSearchTerm('');
                  }} 
                  className="mt-4 text-patriot-red hover:text-patriot-red-dark font-medium"
                >
                  Clear all filters
                </button>
              )}
            </div>
          ) : (
            <div className="space-y-6">
              {currentEvents.map((event) => (
                <motion.div 
                  key={event.id} 
                  initial={{ opacity: 0, y: 20 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.4 }} 
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
                  onClick={() => openEventDetails(event)}
                >
                  <div className="flex flex-col md:flex-row">
                    <div className="md:w-1/4 relative">
                      <img 
                        src={event.image} 
                        alt={event.title} 
                        className="w-full h-48 md:h-full object-cover" 
                      />
                      <div className="absolute top-2 right-2">
                        <span className="bg-patriot-red text-white px-2 py-1 rounded-full text-xs font-medium">
                          {event.category}
                        </span>
                      </div>
                      {event.isVirtual && (
                        <div className="absolute top-2 left-2">
                          <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                            <SafeIcon icon={FiVideo} className="h-3 w-3 mr-1" />
                            Virtual
                          </span>
                        </div>
                      )}
                      {event.isRecurring && (
                        <div className="absolute bottom-2 left-2">
                          <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                            <SafeIcon icon={FiRepeat} className="h-3 w-3 mr-1" />
                            Recurring
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="p-6 md:w-3/4">
                      <h3 className="text-xl font-bold text-patriot-navy mb-2">{event.title}</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 text-sm text-gray-600">
                        <div className="flex items-center">
                          <SafeIcon icon={FiCalendar} className="h-4 w-4 mr-2 text-gray-500" />
                          <span>{formatDate(event.date)}</span>
                        </div>
                        <div className="flex items-center">
                          <SafeIcon icon={FiClock} className="h-4 w-4 mr-2 text-gray-500" />
                          <span>
                            {formatTime(event.time)} {event.endTime && ` - ${formatTime(event.endTime)}`}
                          </span>
                        </div>
                        <div className="flex items-center">
                          <SafeIcon icon={FiMapPin} className="h-4 w-4 mr-2 text-gray-500" />
                          <span>{event.location}</span>
                        </div>
                        <div className="flex items-center">
                          <SafeIcon icon={FiUser} className="h-4 w-4 mr-2 text-gray-500" />
                          <span>Hosted by {event.organizer}</span>
                        </div>
                      </div>
                      {event.isRecurring && (
                        <div className="mb-4 flex items-center text-sm text-green-600">
                          <SafeIcon icon={FiRepeat} className="h-4 w-4 mr-2" />
                          <span>
                            {generateRecurrenceTextFromPattern(event.recurrencePattern)}
                          </span>
                        </div>
                      )}
                      <p className="text-gray-600 mb-6 line-clamp-2 md:line-clamp-none">{event.description}</p>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-500 hidden md:block">{event.venue}</span>
                        <div className="flex flex-wrap gap-2 ml-auto">
                          <button 
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(generateGoogleCalendarLink(event), '_blank');
                            }} 
                            className="bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600 transition-colors duration-200 flex items-center text-sm"
                          >
                            <SafeIcon icon={FiCalendar} className="h-4 w-4 mr-1" />
                            <span className="hidden sm:inline">Add to Calendar</span>
                          </button>
                          {event.rsvpLink && (
                            <a 
                              href={event.rsvpLink} 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              onClick={(e) => e.stopPropagation()} 
                              className="bg-patriot-red text-white px-4 py-2 rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 flex items-center"
                            >
                              RSVP
                              <SafeIcon icon={FiExternalLink} className="ml-2 h-4 w-4" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>

        {/* Past Events */}
        {showPastEvents && (
          <div className="mb-10">
            <h2 className="text-2xl font-bold text-patriot-navy mb-6 flex items-center flex-wrap">
              <SafeIcon icon={FiCalendar} className="h-6 w-6 mr-2 text-gray-500" />
              Past Events
              {(selectedState || selectedCity) && (
                <span className="ml-2 text-lg text-gray-600 font-normal">
                  {selectedCity ? `in ${selectedCity}, ${selectedState}` : selectedState ? `in ${selectedState}` : ''}
                </span>
              )}
            </h2>

            {pastEvents.length === 0 ? (
              <div className="bg-white rounded-lg shadow-md p-8 text-center">
                <p className="text-gray-600">No past events found matching your criteria.</p>
              </div>
            ) : (
              <div className="space-y-6">
                {pastEvents.map((event) => (
                  <motion.div 
                    key={event.id} 
                    initial={{ opacity: 0, y: 20 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.4 }} 
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 opacity-75 cursor-pointer"
                    onClick={() => openEventDetails(event)}
                  >
                    <div className="flex flex-col md:flex-row">
                      <div className="md:w-1/4 relative">
                        <img 
                          src={event.image} 
                          alt={event.title} 
                          className="w-full h-48 md:h-full object-cover filter grayscale" 
                        />
                        <div className="absolute top-2 right-2">
                          <span className="bg-gray-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                            {event.category}
                          </span>
                        </div>
                        {event.isVirtual && (
                          <div className="absolute top-2 left-2">
                            <span className="bg-blue-500 bg-opacity-75 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                              <SafeIcon icon={FiVideo} className="h-3 w-3 mr-1" />
                              Virtual
                            </span>
                          </div>
                        )}
                        {event.isRecurring && (
                          <div className="absolute bottom-2 left-2">
                            <span className="bg-green-500 bg-opacity-75 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                              <SafeIcon icon={FiRepeat} className="h-3 w-3 mr-1" />
                              Recurring
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="p-6 md:w-3/4">
                        <h3 className="text-xl font-bold text-patriot-navy mb-2">{event.title}</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 text-sm text-gray-600">
                          <div className="flex items-center">
                            <SafeIcon icon={FiCalendar} className="h-4 w-4 mr-2 text-gray-500" />
                            <span>{formatDate(event.date)}</span>
                          </div>
                          <div className="flex items-center">
                            <SafeIcon icon={FiClock} className="h-4 w-4 mr-2 text-gray-500" />
                            <span>
                              {formatTime(event.time)} {event.endTime && ` - ${formatTime(event.endTime)}`}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <SafeIcon icon={FiMapPin} className="h-4 w-4 mr-2 text-gray-500" />
                            <span>{event.location}</span>
                          </div>
                          <div className="flex items-center">
                            <SafeIcon icon={FiUser} className="h-4 w-4 mr-2 text-gray-500" />
                            <span>Hosted by {event.organizer}</span>
                          </div>
                        </div>
                        {event.isRecurring && (
                          <div className="mb-4 flex items-center text-sm text-green-600 text-opacity-75">
                            <SafeIcon icon={FiRepeat} className="h-4 w-4 mr-2" />
                            <span>
                              {generateRecurrenceTextFromPattern(event.recurrencePattern)}
                            </span>
                          </div>
                        )}
                        <p className="text-gray-600 mb-4 line-clamp-2 md:line-clamp-none">{event.description}</p>
                        <span className="text-sm text-gray-500">{event.venue}</span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Event Detail Modal */}
        {showEventDetail && selectedEvent && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }} 
              className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="relative">
                <img 
                  src={selectedEvent.image} 
                  alt={selectedEvent.title} 
                  className="w-full h-48 md:h-64 lg:h-80 object-cover" 
                />
                <button 
                  onClick={closeEventDetails} 
                  className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors duration-200"
                >
                  <SafeIcon icon={FiX} className="h-5 w-5 text-gray-700" />
                </button>
                <div className="absolute bottom-4 left-4 flex flex-wrap gap-2">
                  <span className="bg-patriot-red text-white px-3 py-1 rounded-full text-sm font-medium">
                    {selectedEvent.category}
                  </span>
                  {selectedEvent.isVirtual && (
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium flex items-center">
                      <SafeIcon icon={FiVideo} className="h-4 w-4 mr-1" />
                      Virtual Event
                    </span>
                  )}
                  {selectedEvent.isRecurring && (
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium flex items-center">
                      <SafeIcon icon={FiRepeat} className="h-4 w-4 mr-1" />
                      Recurring Event
                    </span>
                  )}
                </div>
              </div>
              <div className="p-6">
                <h2 className="text-xl md:text-2xl font-bold text-patriot-navy mb-4">{selectedEvent.title}</h2>
                <p className="text-gray-600 mb-6">{selectedEvent.description}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8">
                  {/* Date and Time */}
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="flex items-center mb-3">
                      <div className="bg-patriot-red bg-opacity-10 rounded-full p-2 mr-3">
                        <SafeIcon icon={FiCalendar} className="h-5 w-5 text-patriot-red" />
                      </div>
                      <div>
                        <h3 className="font-medium text-patriot-navy">Date & Time</h3>
                        <p className="text-gray-600 text-sm">
                          {selectedEvent.isRecurring ? getNextOccurrenceDate(selectedEvent) : formatDate(selectedEvent.date)}
                        </p>
                      </div>
                    </div>
                    <div className="ml-12">
                      <div className="flex items-center">
                        <SafeIcon icon={FiClock} className="h-4 w-4 text-gray-500 mr-2" />
                        <span className="text-sm">
                          {formatTime(selectedEvent.time)} {selectedEvent.endTime && ` - ${formatTime(selectedEvent.endTime)}`}
                        </span>
                      </div>
                      {selectedEvent.isRecurring && (
                        <div className="flex items-center mt-2 text-green-600">
                          <SafeIcon icon={FiRepeat} className="h-4 w-4 mr-2" />
                          <span className="text-sm">
                            {generateRecurrenceTextFromPattern(selectedEvent.recurrencePattern)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Location */}
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="flex items-center mb-3">
                      <div className="bg-patriot-red bg-opacity-10 rounded-full p-2 mr-3">
                        <SafeIcon icon={selectedEvent.isVirtual ? FiVideo : FiMapPin} className="h-5 w-5 text-patriot-red" />
                      </div>
                      <div>
                        <h3 className="font-medium text-patriot-navy">
                          {selectedEvent.isVirtual ? 'Virtual Event' : 'Location'}
                        </h3>
                        <p className="text-gray-600 text-sm">
                          {selectedEvent.isVirtual ? 'Online' : selectedEvent.location}
                        </p>
                      </div>
                    </div>
                    <div className="ml-12">
                      {selectedEvent.isVirtual ? (
                        <a 
                          href={selectedEvent.virtualLink} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="text-blue-600 hover:underline text-sm flex items-center"
                        >
                          <SafeIcon icon={FiLink} className="h-4 w-4 mr-2" />
                          Join Virtual Event
                        </a>
                      ) : (
                        <p className="text-sm text-gray-600">
                          {selectedEvent.venue}
                          {selectedEvent.address && <span><br />{selectedEvent.address}</span>}
                        </p>
                      )}
                    </div>
                  </div>
                  
                  {/* Host */}
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="flex items-center mb-3">
                      <div className="bg-patriot-red bg-opacity-10 rounded-full p-2 mr-3">
                        <SafeIcon icon={FiUser} className="h-5 w-5 text-patriot-red" />
                      </div>
                      <div>
                        <h3 className="font-medium text-patriot-navy">Host</h3>
                        <p className="text-gray-600 text-sm">{selectedEvent.organizer}</p>
                      </div>
                    </div>
                    {selectedEvent.hostProfile && (
                      <div className="ml-12">
                        <a 
                          href={selectedEvent.hostProfile} 
                          className="text-patriot-red hover:text-patriot-red-dark text-sm flex items-center"
                        >
                          View Host Profile
                          <SafeIcon icon={FiChevronRight} className="h-4 w-4 ml-1" />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Action Buttons */}
                <div className="bg-gray-50 rounded-lg p-4 md:p-6 mb-6">
                  <h3 className="text-lg font-semibold text-patriot-navy mb-4">Join This Event</h3>
                  <div className="flex flex-wrap gap-3">
                    {selectedEvent.rsvpLink && (
                      <a 
                        href={selectedEvent.rsvpLink} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="px-4 py-2 bg-patriot-red text-white rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 inline-flex items-center"
                      >
                        RSVP Now
                        <SafeIcon icon={FiExternalLink} className="ml-2 h-4 w-4" />
                      </a>
                    )}
                    <a 
                      href={generateGoogleCalendarLink(selectedEvent)} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 inline-flex items-center"
                    >
                      <SafeIcon icon={FiCalendar} className="mr-2 h-4 w-4" />
                      Add to Google Calendar
                    </a>
                    <button 
                      onClick={() => generateICalFile(selectedEvent)} 
                      className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 inline-flex items-center"
                    >
                      <SafeIcon icon={FiDownload} className="mr-2 h-4 w-4" />
                      Download iCal File
                    </button>
                    <a 
                      href={generateAppleCalendarLink(selectedEvent)} 
                      download={`${selectedEvent.title.replace(/\s+/g, '_')}.ics`} 
                      className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-black transition-colors duration-200 inline-flex items-center"
                    >
                      <span className="mr-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                          <path d="M11.182 7.058c-.018-1.969 1.607-2.918 1.68-2.964-.913-1.334-2.338-1.518-2.842-1.54-1.212-.123-2.366.714-2.983.714-.614 0-1.565-.697-2.572-.677-1.323.02-2.544.77-3.229 1.955-1.374 2.385-.351 5.921.991 7.855.655.95 1.439 2.014 2.466 1.976 1.006-.039 1.362-.643 2.558-.643 1.196 0 1.532.643 2.575.622 1.062-.02 1.737-.966 2.387-1.918.751-1.1 1.06-2.163 1.079-2.22-.024-.01-2.068-.793-2.088-3.147l-.022-.013zM9.366 2.132c.555-.672.928-1.608.827-2.54-.8.033-1.77.534-2.344 1.206-.515.596-.967 1.548-.845 2.458.891.07 1.802-.456 2.358-1.122l.004-.002z" />
                        </svg>
                      </span>
                      Add to Apple Calendar
                    </a>
                  </div>
                </div>
                
                {/* Map (if not virtual) */}
                {!selectedEvent.isVirtual && selectedEvent.address && (
                  <div className="mb-6">
                    <h3 className="font-medium text-patriot-navy mb-2">Map</h3>
                    <div className="h-64 bg-gray-200 rounded-lg">
                      <iframe 
                        title="Event Location" 
                        width="100%" 
                        height="100%" 
                        frameBorder="0" 
                        style={{ border: 0, borderRadius: '0.5rem' }} 
                        src={`https://www.google.com/maps/embed/v1/place?key=YOUR_API_KEY&q=${encodeURIComponent(selectedEvent.address)}`} 
                        allowFullScreen
                      ></iframe>
                    </div>
                    <p className="mt-2 text-xs text-gray-500">
                      Map view is a placeholder. In a production app, this would display an actual map of the location.
                    </p>
                  </div>
                )}
                
                {/* Close Button */}
                <div className="flex justify-center">
                  <button 
                    onClick={closeEventDetails} 
                    className="px-4 py-2 bg-patriot-navy text-white rounded-lg hover:bg-opacity-90 transition-colors duration-200"
                  >
                    Close
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}

        {/* Add Event Modal - Simplified single-page form */}
        {showAddEventForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }} 
              animate={{ opacity: 1, scale: 1 }} 
              className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl md:text-2xl font-bold text-patriot-navy">Submit an Event</h2>
                  <button 
                    onClick={() => {
                      setShowAddEventForm(false);
                      setSubmissionStatus({ type: '', message: '' });
                    }} 
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <SafeIcon icon={FiX} className="h-6 w-6" />
                  </button>
                </div>
                
                {/* Form Submission Message */}
                {submissionStatus.message && (
                  <div className={`mb-6 p-4 rounded-md ${
                    submissionStatus.type === 'error' 
                      ? 'bg-red-50 text-red-700 border border-red-200' 
                      : 'bg-green-50 text-green-700 border border-green-200'
                  }`}>
                    <div className="flex items-center">
                      <SafeIcon 
                        icon={submissionStatus.type === 'error' ? FiAlertCircle : FiCheck} 
                        className={`h-5 w-5 ${submissionStatus.type === 'error' ? 'text-red-500' : 'text-green-500'} mr-2`} 
                      />
                      <p>{submissionStatus.message}</p>
                    </div>
                  </div>
                )}
                
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Basic Info Section */}
                    <div className="md:col-span-2">
                      <h3 className="text-lg font-semibold text-patriot-navy mb-4 pb-2 border-b border-gray-200">Event Details</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div className="md:col-span-2">
                          <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
                            Event Title*
                          </label>
                          <input 
                            type="text" 
                            id="title" 
                            name="title" 
                            value={newEvent.title} 
                            onChange={handleInputChange} 
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                            placeholder="Enter event title" 
                            required 
                          />
                        </div>
                        <div>
                          <label htmlFor="organizer" className="block text-sm font-medium text-gray-700 mb-1">
                            Host/Organizer*
                          </label>
                          <div className="relative">
                            <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                            <input 
                              type="text" 
                              id="organizer" 
                              name="organizer" 
                              value={newEvent.organizer} 
                              onChange={handleInputChange} 
                              className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                              placeholder="Name of organizing group/person" 
                              required 
                            />
                          </div>
                        </div>
                        <div>
                          <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
                            Event Category
                          </label>
                          <select 
                            id="category" 
                            name="category" 
                            value={newEvent.category} 
                            onChange={handleInputChange} 
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent"
                          >
                            {categories.filter(cat => cat !== 'All').map((category) => (
                              <option key={category} value={category}>
                                {category}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="mb-6">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                          Event Description*
                        </label>
                        <div className="relative">
                          <SafeIcon icon={FiInfo} className="absolute left-3 top-3 text-gray-400 h-4 w-4" />
                          <textarea 
                            id="description" 
                            name="description" 
                            rows="3" 
                            value={newEvent.description} 
                            onChange={handleInputChange} 
                            className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                            placeholder="Provide details about your event..." 
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    
                    {/* Date and Time Section */}
                    <div>
                      <h3 className="text-lg font-semibold text-patriot-navy mb-4 pb-2 border-b border-gray-200">Date & Time</h3>
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                            Event Date*
                          </label>
                          <div className="relative">
                            <SafeIcon icon={FiCalendar} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                            <input 
                              type="date" 
                              id="date" 
                              name="date" 
                              value={newEvent.date} 
                              onChange={handleInputChange} 
                              className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1">
                              Start Time*
                            </label>
                            <div className="relative">
                              <SafeIcon icon={FiClock} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                              <input 
                                type="time" 
                                id="time" 
                                name="time" 
                                value={newEvent.time} 
                                onChange={handleInputChange} 
                                className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                required 
                              />
                            </div>
                          </div>
                          <div>
                            <label htmlFor="endTime" className="block text-sm font-medium text-gray-700 mb-1">
                              End Time
                            </label>
                            <div className="relative">
                              <SafeIcon icon={FiClock} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                              <input 
                                type="time" 
                                id="endTime" 
                                name="endTime" 
                                value={newEvent.endTime} 
                                onChange={handleInputChange} 
                                className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mt-4">
                          <div className="flex items-center mb-2">
                            <input 
                              id="isRecurring" 
                              name="isRecurring" 
                              type="checkbox" 
                              checked={newEvent.isRecurring} 
                              onChange={handleInputChange} 
                              className="h-4 w-4 text-patriot-red focus:ring-patriot-red border-gray-300 rounded" 
                            />
                            <label htmlFor="isRecurring" className="ml-2 block text-sm text-gray-700">
                              This is a recurring event
                            </label>
                          </div>
                          {newEvent.isRecurring && (
                            <div className="ml-6 mt-3 space-y-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                              <div>
                                <label htmlFor="recurrencePattern.frequency" className="block text-sm font-medium text-gray-700 mb-1">
                                  Frequency*
                                </label>
                                <select 
                                  id="recurrencePattern.frequency" 
                                  name="recurrencePattern.frequency" 
                                  value={newEvent.recurrencePattern.frequency} 
                                  onChange={handleInputChange} 
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                  required={newEvent.isRecurring}
                                >
                                  <option value="">Select a frequency</option>
                                  {frequencies.map((freq) => (
                                    <option key={freq.value} value={freq.value}>
                                      {freq.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {(newEvent.recurrencePattern.frequency === 'weekly' || 
                                newEvent.recurrencePattern.frequency === 'biweekly' || 
                                newEvent.recurrencePattern.frequency === 'monthly') && (
                                <div>
                                  <label htmlFor="recurrencePattern.weekday" className="block text-sm font-medium text-gray-700 mb-1">
                                    Day of the Week*
                                  </label>
                                  <select 
                                    id="recurrencePattern.weekday" 
                                    name="recurrencePattern.weekday" 
                                    value={newEvent.recurrencePattern.weekday} 
                                    onChange={handleInputChange} 
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                    required={newEvent.recurrencePattern.frequency === 'weekly' || 
                                             newEvent.recurrencePattern.frequency === 'biweekly' || 
                                             newEvent.recurrencePattern.frequency === 'monthly'}
                                  >
                                    <option value="">Select day</option>
                                    {weekdays.map((day) => (
                                      <option key={day.value} value={day.value}>
                                        {day.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              {newEvent.recurrencePattern.frequency === 'monthly' && (
                                <div>
                                  <label htmlFor="recurrencePattern.monthDay" className="block text-sm font-medium text-gray-700 mb-1">
                                    Which Week*
                                  </label>
                                  <select 
                                    id="recurrencePattern.monthDay" 
                                    name="recurrencePattern.monthDay" 
                                    value={newEvent.recurrencePattern.monthDay} 
                                    onChange={handleInputChange} 
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                    required={newEvent.recurrencePattern.frequency === 'monthly'}
                                  >
                                    <option value="">Select week</option>
                                    {monthDays.map((day) => (
                                      <option key={day.value} value={day.value}>
                                        {day.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div>
                                <label htmlFor="recurrencePattern.endDate" className="block text-sm font-medium text-gray-700 mb-1">
                                  End Date (Optional)
                                </label>
                                <input 
                                  type="date" 
                                  id="recurrencePattern.endDate" 
                                  name="recurrencePattern.endDate" 
                                  value={newEvent.recurrencePattern.endDate} 
                                  onChange={handleInputChange} 
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                  min={newEvent.date} 
                                />
                                <p className="mt-1 text-xs text-gray-500">
                                  Leave blank if the event recurs indefinitely
                                </p>
                              </div>
                              {newEvent.recurrencePattern.frequency && (
                                <div className="p-3 bg-blue-50 rounded-lg">
                                  <div className="flex items-center">
                                    <SafeIcon icon={FiInfo} className="h-5 w-5 text-blue-500 mr-2" />
                                    <p className="text-sm text-blue-700">
                                      <span className="font-medium">Recurring Event:</span>{' '}
                                      {generateRecurrenceText() || 'Select options above to see pattern'}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {/* Location Section */}
                    <div>
                      <h3 className="text-lg font-semibold text-patriot-navy mb-4 pb-2 border-b border-gray-200">Location</h3>
                      <div className="space-y-4">
                        <div className="mb-4">
                          <div className="flex items-center mb-2">
                            <input 
                              id="isVirtual" 
                              name="isVirtual" 
                              type="checkbox" 
                              checked={newEvent.isVirtual} 
                              onChange={handleInputChange} 
                              className="h-4 w-4 text-patriot-red focus:ring-patriot-red border-gray-300 rounded" 
                            />
                            <label htmlFor="isVirtual" className="ml-2 block text-sm text-gray-700">
                              This is a virtual event
                            </label>
                          </div>
                        </div>
                        {newEvent.isVirtual ? (
                          <div>
                            <label htmlFor="virtualLink" className="block text-sm font-medium text-gray-700 mb-1">
                              Virtual Meeting Link*
                            </label>
                            <div className="relative">
                              <SafeIcon icon={FiLink} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                              <input 
                                type="url" 
                                id="virtualLink" 
                                name="virtualLink" 
                                value={newEvent.virtualLink} 
                                onChange={handleInputChange} 
                                className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                placeholder="https://zoom.us/j/123456789" 
                                required={newEvent.isVirtual} 
                              />
                            </div>
                            <p className="mt-1 text-xs text-gray-500">
                              Provide a link to your Zoom, Teams, Google Meet, or other virtual meeting platform
                            </p>
                          </div>
                        ) : (
                          <>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                              <div>
                                <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
                                  State*
                                </label>
                                <select 
                                  id="state" 
                                  name="state" 
                                  value={newEvent.state} 
                                  onChange={handleInputChange} 
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                  required={!newEvent.isVirtual}
                                >
                                  <option value="">Select State</option>
                                  {availableStates.map(state => (
                                    <option key={state} value={state}>{state}</option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                                  City*
                                </label>
                                <input 
                                  type="text" 
                                  id="city" 
                                  name="city" 
                                  value={newEvent.city} 
                                  onChange={handleInputChange} 
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                  placeholder="e.g., Richmond" 
                                  required={!newEvent.isVirtual} 
                                />
                              </div>
                            </div>
                            <div>
                              <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">
                                Location Display*
                              </label>
                              <div className="relative">
                                <SafeIcon icon={FiMapPin} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                                <input 
                                  type="text" 
                                  id="location" 
                                  name="location" 
                                  value={newEvent.location} 
                                  onChange={handleInputChange} 
                                  className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                  placeholder="e.g., Richmond, VA" 
                                  required={!newEvent.isVirtual} 
                                />
                              </div>
                              <p className="mt-1 text-xs text-gray-500">
                                This is how the location will display in event listings
                              </p>
                            </div>
                            <div>
                              <label htmlFor="venue" className="block text-sm font-medium text-gray-700 mb-1">
                                Venue Name*
                              </label>
                              <input 
                                type="text" 
                                id="venue" 
                                name="venue" 
                                value={newEvent.venue} 
                                onChange={handleInputChange} 
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                placeholder="e.g., Convention Center" 
                                required={!newEvent.isVirtual} 
                              />
                            </div>
                            <div>
                              <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
                                Full Address
                              </label>
                              <input 
                                type="text" 
                                id="address" 
                                name="address" 
                                value={newEvent.address} 
                                onChange={handleInputChange} 
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                                placeholder="123 Main St, Richmond, VA 23219" 
                              />
                              <p className="mt-1 text-xs text-gray-500">
                                Providing a full address helps attendees find your event and enables map functionality
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  {/* Additional Information Section */}
                  <div className="border-t border-gray-200 pt-6">
                    <h3 className="text-lg font-semibold text-patriot-navy mb-4">Additional Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label htmlFor="rsvpLink" className="block text-sm font-medium text-gray-700 mb-1">
                          RSVP Link
                        </label>
                        <div className="relative">
                          <SafeIcon icon={FiLink} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                          <input 
                            type="url" 
                            id="rsvpLink" 
                            name="rsvpLink" 
                            value={newEvent.rsvpLink} 
                            onChange={handleInputChange} 
                            className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent" 
                            placeholder="https://example.com/rsvp" 
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Event Image
                        </label>
                        <div className="flex items-center justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-lg">
                          <div className="space-y-1 text-center">
                            <SafeIcon icon={FiUpload} className="mx-auto h-12 w-12 text-gray-400" />
                            <div className="flex text-sm text-gray-600">
                              <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-patriot-red hover:text-patriot-red-dark">
                                <span>Upload an image</span>
                                <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                              </label>
                              <p className="pl-1">or drag and drop</p>
                            </div>
                            <p className="text-xs text-gray-500">
                              PNG, JPG, GIF up to 10MB
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center mt-6">
                      <input 
                        id="terms" 
                        type="checkbox" 
                        required 
                        className="h-4 w-4 text-patriot-red focus:ring-patriot-red border-gray-300 rounded" 
                      />
                      <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                        I confirm this event promotes Republican values and follows community guidelines
                      </label>
                    </div>
                  </div>
                  
                  {/* Submit Button */}
                  <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 mt-6">
                    <button 
                      type="button" 
                      onClick={() => setShowAddEventForm(false)} 
                      className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-patriot-red"
                    >
                      Cancel
                    </button>
                    <button 
                      type="submit" 
                      className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-white bg-patriot-red hover:bg-patriot-red-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-patriot-red"
                    >
                      Submit Event
                    </button>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>
        )}

        {/* Call to Action */}
        <div className="bg-patriot-navy rounded-lg p-8 text-white text-center">
          <h2 className="text-2xl font-bold mb-4">Don't See Your Event?</h2>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Help us build a comprehensive calendar of Republican events across America. Submit your event for review and help connect patriots in your area.
          </p>
          <button 
            onClick={() => setShowAddEventForm(true)} 
            className="bg-patriot-red text-white px-6 py-3 rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 font-medium"
          >
            Submit Your Event
          </button>
        </div>
      </div>
    </div>
  );
};

export default Events;